export default "__VITE_ASSET__B$yZqGc6__"